
//此处要求组件的name和路由name相同

export const pubRoutes = [
  {
    path: '*',
    name: "notFound",
    component: () => import('@/views/error/NotFound.vue'),
    meta:{
    }
  },
  {
    path: '/404',
    name: '404',
    meta: {
        title: 'Not Found'
    },
    component: () => import('@/views/error/NotFound.vue')
  },
  {
    path: '/500',
    name: '500',
    meta: {
      title: 'Server Error'
    },
    component: () => import('@/views/error/Error.vue')
  }
];

export const sysRoutes = [
	{
		path:'/',
		name:'root',
		redirect:'/main',
	},
	{
		path:'/main',
		name:'main',
		component: resolve => require(['@/views/desktop/Main.vue'], resolve)	
	},
	{
		path:'/desktop',
		name:'desktop',
		component: resolve => require(['@/views/desktop/Desktop.vue'], resolve),
		children:[
			{
                path: 'dashboard',	
                name: 'dashboard',		
                component: resolve => require(['@/views/dashboard/Dashboard.vue'], resolve),
                props:true,
                meta:{compPath:'/dashboard/Dashboard.vue'} 
			},
			
            {
                path: 'webpage',
                name: 'webpage',
                component: resolve => require(['@/views/webpage/Webpage.vue'], resolve),
                props:true,
                meta:{compPath:'/webpage/Webpage.vue'}
            },
		]		
	},
	{
		path: '/login',
		name: 'login',
		component: resolve => require(['@/views/login/Login.vue'], resolve)
	},
	{
		path: '/auth',
		name: 'auth',
		component: resolve => require(['@/views/login/Auth.vue'], resolve)
	},
	{
		path:'/test',
		name:'test',	
		component: resolve => require(['@/views/test/Test.vue'], resolve),
		children:[			
		]		
    },
    {
        path:'/testNew',
        name:'testNew',
        component: resolve => require(['@/views/test/testNew.vue'], resolve),
        children:[
        ]
    },
    {
        path:'/printItem',
        name:'printItem',
        component: resolve => require(['@/views/sm/market/groupon/groupPrintIframe.vue'], resolve),
        children:[
        ]
    },
    {
        path:'/workBench',
        name:'workBench',
        component: resolve => require(['@/views/alarm/workbench/benchInfo.vue'], resolve),
        children:[
        ]
    },
    {
		path: '/sm-provider-link-login',
		name: 'sm-provider-link-login',
		component: resolve => require(['@/views/login/SmProviderLinkLogin.vue'], resolve)
    },
	{
		path: '/oa-warn-link-login',
		name: 'oa-warn-link-login',
		component: resolve => require(['@/views/login/OaWarnLinkLogin.vue'], resolve)
	},
    {
		path: '/oa-link-login',
		name: 'oa-link-login',
		component: resolve => require(['@/views/login/OaLinkLogin.vue'], resolve)
    },
    {
        //需要修改新建sm.js,并导入路由
		path:'/redirect',
        name:'redirect',
        component: resolve => require(['@/views/desktop/RedirectRoot.vue'], resolve),
        props:true,
		children:[
			{
                path: 'provider/return-order-confirm',	
                name: 'sm-provider-return-order-confirm',		
                component: resolve => require(['@/views/sm/provider/order/return-order-confirm/ReturnOrderConfirm.vue'], resolve),
                props:true,
                meta:{compPath:'/sm/provider/order/return-order-confirm/ReturnOrderConfirm.vue',page:{id:'341'}} 
			},
            {
				path:'/vender-apointment',
				name:'sm-provider-vender-appointment',
				component: resolve => require(['@/views/appointment/VenderAppointment.vue'], resolve),
				props:true,
                meta:{compPath:'/appointment/VenderAppointment.vue',page:{id:'-1'}} 
				
			}, 
		]		
	},
    
];

//暂时只支持一级合并，即不支持routes的下级自动并入
export function mergeRoutes(top,parentName,routes){
    for(var idx in top){
        if(top[idx].name==parentName){
            if(!top[idx].children){
                top[idx].children=[];
            }
           
            top[idx].children=top[idx].children.concat(routes);
            return;
        }
    }
};